<script>
import AnnouncementsApi from "@/services/announcements-api";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import carousel from 'vue-owl-carousel'
// import simplebar from "simplebar-vue";

export default {

    props: {
      
      propDisplayTitle: {
          type:Boolean,
          default:true
        },

      propWhiteBackground: {
          type:Boolean,
          default:true
        },

      propFullwidth: {
          type:Boolean,
          default:false
        },

    },

    components: {
      // carousel/*, simplebar*/
    },
    data () {
        return {
          highlightsList:[],

        }

    },
    mounted () {
     this.getPromotionsAndNews();
  },

methods: {

  getPromotionsAndNews() {
        AnnouncementsApi.getPromotionsAndNews(1, 100)
            .then(result => {
              if(result){
                this.highlightsList=result.list;
              }
            })
      },

},

  watch: {
   

    },
  };


</script>

<style>

#high-carousel img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

#high-carousel p {
  padding-right: 10px; 
}

#high-carousel p::-webkit-scrollbar {
  width: 5px;
}

#high-carousel p::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* replace with your desired track color */
}

#high-carousel p::-webkit-scrollbar-thumb {
  background-color: #888; /* replace with your desired thumb color */
  border-radius: 5px; /* replace with your desired thumb border radius */
}

#high-carousel p::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* replace with your desired hover thumb color */
}

#annoucement-title-small {
  
  box-sizing: border-box;
    font-family: "Open Sans", mm-main, arial, sans-serif;
    letter-spacing: normal;
    font-weight: 600;
    width: 100%;
    max-width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    text-align: left;
    animation: 0s ease 0s 1 normal none running none !important;
    -webkit-line-clamp: 2;
    margin-top: 0px;
    line-height: 18px;
    height: 36px;
}

</style>

<template>

<!-- :style="{ background: `linear-gradient(to right, #dddddde6 25%,rgba(0, 52, 58, 0.48) 90%), url(${require('@/assets/images/a-propos.jpg')})`, backgroundSize: 'cover', backgroundPosition: 'center' }" -->
<div class="row pt-4 pb-4 p-4 p-lg-0 pt-lg-4 pb-lg-4 bg-light" v-if="highlightsList.length > 0" >
  <div class="col-12 pb-0 pt-0 pb-lg-4 pt-lg-4">

        <div v-if="propDisplayTitle" class="row mb-3" :class="propFullwidth ? '' : 'home-page-80-width'">
            <div class="col-12 text-left">
              <h2 class="text-dark font-weight-bold">
                <div class="row ">

                    <div class="col-12 text-primary text-center text-uppercase" style="letter-spacing: 0.05em; font-weight: 600; font-size: 1.5rem;">

                        Nos Actualités
                    </div>

                </div>
              </h2>
                <!-- <h3 class="text-secondary text-center">Explorez nos dernières actualités et offres exceptionnelles</h3> -->
                <!-- <div class="text-dark font-weight-bold text-md-center text-justify font-size-14 home-page-80-width mt-4  ">
                Chez SOPROPHA, nous nous engageons à garantir une distribution optimale des médicaments à travers tout le territoire. Notre mission est d'assurer un approvisionnement rapide et fiable pour répondre aux besoins des pharmacies, contribuant ainsi à la santé publique. Explorez également nos offres promotionnelles exclusives, spécialement conçues pour soutenir nos partenaires et clients.
                </div> -->
            </div>
        </div>

          <div class="row mt-0 mb-2" :class="propFullwidth ? '' : 'home-page-80-width'">
            <div class="col-12">

                  <div class="row " >
                    <div v-for="announcement in highlightsList" :key="announcement.id" class="col-md-4 col-12 mb-5 pr-0 pl-0 pr-md-5 pl-md-5" >

                      <div class="card m-0 h-100 " style="border-radius: 5px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);">
                        <div class="card-body p-0" >

                            


                          <img class="text-center " style="border-radius: 5px 5px 0px 0px; " max-height="450px" width="100%" :src="'/api/image/get/' + announcement.image" alt="Announcement image">


                          <div class="p-2">

                          <h5
                            v-if="propDisplayTitle"
                            class="card-title text-primary text-uppercase font-weight-bold text-center mt-3"
                            :title="announcement.title"
                          >
                            {{ announcement.title }}
                          </h5>
                          <p
                            v-if="propDisplayTitle"
                            class="card-text text-justify font-size-14 text-dark p-2 m-0 pb-4"
                            v-html="announcement.description"
                          ></p>


                            <div class="row text-dark font-size-12 mt-auto" style="position: absolute;bottom: 1%; width: 95%;">
                              <div class="col-6 text-left text-dark font-weight-bold">
                                <i class="bx bx-calendar mr-1"></i> {{ announcement.date }}


                              </div>

                              <div class="col-6 text-right text-dark font-weight-bold">

                                <b-badge v-if="announcement.tag" variant="dark" class="font-size-12 font-weight-bold" >{{announcement.tag}} </b-badge>

                              </div>



                          </div>
                            

                          </div>

                          
                        </div>

                      </div>


                    </div>
                  </div>

            </div>
          </div>
      </div>
    </div>
</template>                 
               